import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { ProductLicenseBundleName } from '../../core/constants/constants';
import { ProductLicense } from '../../core/interfaces/product-licenses-interfaces';


@Pipe({
    name: 'filterBundles'
})
export class FilterBundles implements PipeTransform {

    transform(bundles: ProductLicense[], bundleName: string): any {
        return bundles.filter(item => item.bundleName === bundleName);
    }

}
